/* Brain Freeze blog (Oct 2026). FAQ accordion: Osmo Vault "Accordion CSS Animation" (accordion-css-animation),
   toggle is a <button> with aria-expanded. Copy-link button for the share row. */
(function () {
  function initAccordionCSS() {
    document.querySelectorAll('[data-accordion-css-init]').forEach(function (acc) {
      if (acc.dataset.bfReady) return; acc.dataset.bfReady = '1';
      var closeSiblings = acc.getAttribute('data-accordion-close-siblings') === 'true';
      acc.addEventListener('click', function (ev) {
        var toggle = ev.target.closest('[data-accordion-toggle]'); if (!toggle) return;
        var item = toggle.closest('[data-accordion-status]'); if (!item) return;
        var isActive = item.getAttribute('data-accordion-status') === 'active';
        item.setAttribute('data-accordion-status', isActive ? 'not-active' : 'active');
        toggle.setAttribute('aria-expanded', String(!isActive));
        if (closeSiblings && !isActive) acc.querySelectorAll('[data-accordion-status="active"]').forEach(function (s) {
          if (s !== item) { s.setAttribute('data-accordion-status', 'not-active'); var t = s.querySelector('[data-accordion-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
        });
      });
    });
  }
  function initCopy() {
    document.querySelectorAll('[data-bf-copy]').forEach(function (b) {
      if (b.dataset.bfReady) return; b.dataset.bfReady = '1';
      b.addEventListener('click', function () {
        var done = function () { var o = b.textContent; b.textContent = 'Link copied'; setTimeout(function () { b.textContent = o; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.bfCopy).then(done, function () {}); 
      });
    });
  }
  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]'); if (!bar || bar.dataset.bfReady) return; bar.dataset.bfReady = '1';
    var boxes = document.querySelectorAll('[data-bf-offer], .bf-sg'); if (!boxes.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var passed = boxes[0].getBoundingClientRect().bottom < 0;
      var onScreen = Array.prototype.some.call(boxes, function (b) { var r = b.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; });
      bar.hidden = !(passed && !onScreen);
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Treat allowance calculator ([[treatcalc]]) */
  function initTreatCalc() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bf-calc]:not([data-bf-ready])'), function (box) {
      box.dataset.bfReady = '1';
      var f = box.querySelector('form'), out = function (sel) { return box.querySelector(sel); };
      var FILLS = [['plain tinned pumpkin', 5], ['plain full-fat Greek yoghurt', 15], ['mashed banana', 13], ['dry kibble', 55], ['peanut butter', 95]];
      var tbsp = function (n) { if (n >= 10) return Math.round(n) + ' tbsp'; var h = Math.round(n * 2) / 2; return (h < 0.5 ? 'under ½' : (h % 1 ? (Math.floor(h) ? Math.floor(h) + '½' : '½') : h)) + ' tbsp'; };
      function calc() {
        var w = parseFloat(f.w.value), kg = f.u.value === 'kg' ? w : w / 2.2046, a = parseFloat(f.a.value);
        if (!(kg > 0.4) || kg > 120) { out('[data-bf-calc-treat]').textContent = '–'; out('[data-bf-calc-day]').textContent = '–'; out('[data-bf-calc-eq]').innerHTML = ''; return; }
        var day = 70 * Math.pow(kg, 0.75) * a, treat = day / 10;
        out('[data-bf-calc-treat]').textContent = Math.round(treat);
        out('[data-bf-calc-day]').textContent = Math.round(day).toLocaleString('en-GB');
        out('[data-bf-calc-eq]').innerHTML = FILLS.map(function (x) { return '<li><b>' + tbsp(treat / x[1]) + '</b> of ' + x[0] + '</li>'; }).join('');
      }
      f.addEventListener('input', calc); f.addEventListener('change', calc); f.addEventListener('submit', function (e) { e.preventDefault(); });
      calc();
    });
  }

  /* Former GIFs, now small MP4s: load and play only while on screen. */
  function initGifVideos() {
    var vids = document.querySelectorAll('video[data-bf-autoplay]:not([data-bf-ready])'); if (!vids.length) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tapToPlay = function (v) { if (v.dataset.bfTap) return; v.dataset.bfTap = '1'; v.controls = true; };
    var play = function (v) {
      if (reduce) { tapToPlay(v); return; }
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var p; try { p = v.play(); } catch (err) { tapToPlay(v); return; }
      if (p && p.catch) p.catch(function () { if (v.readyState >= 2) tapToPlay(v); });
    };
    var start = function (v) {
      v.dataset.bfOn = '1';
      if (!v.dataset.bfLoaded) { v.dataset.bfLoaded = '1'; v.preload = 'auto'; v.load(); }
      play(v);
    };
    vids.forEach(function (v) {
      v.dataset.bfReady = '1';
      ['loadeddata', 'canplay'].forEach(function (ev) { v.addEventListener(ev, function () { if (v.dataset.bfOn === '1' && v.paused) play(v); }); });
      v.addEventListener('error', function () { tapToPlay(v); }, true);
      /* if a phone blocks autoplay (Low Power Mode, data saver), a tap starts it */
      v.addEventListener('click', function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    });
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) start(v);
        else { v.dataset.bfOn = '0'; if (!v.paused) v.pause(); }
      });
    }, { rootMargin: '600px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() { initAccordionCSS(); initCopy(); initSticky(); initTreatCalc(); initGifVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
